import { useSearchParams } from "react-router";
import { SelectGameMode } from "./game-mode";
import GameSettingsComponent from "./game-settings";
import React from "react";
import { config } from "../../../config";
import { ModeFlags } from "../../../hooks/game-settings/useGameSettings";

const gameModeMap: { [key: string]: ModeFlags } = {
  default: {},
  otp: { otp_mode: true },
  "self-insert": { self_insert_mode: true },
  "missing-history": { hidden_history: true },
  solo: { solo_writing: true },
};

const CreateGame = () => {
  const [searchParams] = useSearchParams();
  const gameModeString = searchParams.get("mode");
  const modeFlags = gameModeString ? gameModeMap[gameModeString] : undefined;


  if (modeFlags !== undefined) {
    return <GameSettingsComponent modeFlags={modeFlags} />;
  } else {
    return <SelectGameMode />;
  }
};

export default CreateGame;
